import { Breadcrumbs, Link, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const BroadCrumb = ({ links = [], current }) => {
  const navigate = useNavigate();
  return (
    <Breadcrumbs
      sx={{
        ".MuiTypography-root": {
          fontSize: { lg: "1rem !important", xs: "0.8rem !important" },
          fontWeight: "bold",
          color: { lg: "#000", xs: "#fff" },
        },
        ".MuiBreadcrumbs-separator": {
          marginLeft: "4px  !important",

          marginRight: "4px  !important",
          color: { lg: "#000", xs: "#fff" },
        },
      }}
      separator="/"
    >
      {links?.map((link) => (
        <Link
          onClick={() => navigate(link.path)}
          sx={{ cursor: "pointer" }}
          underline="hover"
          color="inherit"
          key={link.title}
        >
          {link.title}
        </Link>
      ))}
      <Typography
        /* sx={{background:theme => theme.palette.mode === "dark" ? "#6d3808" : "yellow"}}  */ color="text.primary"
      >
        {current}
      </Typography>
    </Breadcrumbs>
  );
};

export default BroadCrumb;
